<template>
<div id="top2">
	<div class="cc-header">
		<dv-decoration-8 :color="['#2e6099', '#060711']" style="width:2.4rem;height:0.3rem;margin-left: 0.2rem;" />
		<div>闸机通行实时监控</div>
		<dv-decoration-8 :reverse="true" :color="['#2e6099', '#060711']" style="width:2.4rem;height:0.3rem;margin-right: 0.2rem;" />
	</div>
    <div class="numChart">
        <div class="cc-details">
            <div>今日通行</div>
            <div v-html="numHtml" style="margin: 0 0.2rem;"></div>
            <div>次</div>
        </div>
        <div class="cc-main-container">
            <div class="ccmc-left">
                <!-- <dv-active-ring-chart class="ccmc-middle" :config="config" :key="key"/> -->
				<div id="pieChart2" class="pieChart"></div>
            </div>
            <div class="ccmc-right">
                <div class="station-info">
                    <div class="legend-color" style="background-color: #00BCD4;"></div>学生<span>{{student}}</span>
                </div>
                <div class="station-info">
                    <div class="legend-color" style="background-color: #FF9800;"></div>教师<span>{{teacher}}</span>
                </div>
                <div class="station-info">
                    <div class="legend-color" style="background-color: #9C27B0;"></div>其他人员<span>{{other}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>


<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
    data() {
        return {
            numHtml: '<div class="card">0</div>',
            student: 0,
            teacher: 0,
            other: 0
        }
    },
    mounted() {
        this.initData();
        // 定时器刷新，5秒
        let _this = this;
        setInterval(() => {
            _this.initData();
        }, 6000);
    },
    methods: {
        initData() {
            let _this = this;
            let myChartPieLeft = echarts.init(document.getElementById("pieChart2"));
            this.$http.get("/dataView/gate/getPassStatistic?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var result = res.data.result;
                    var number = result.count.toString();
                    var option = {
                        color: ["#00BCD4", "#FF9800", "#9C27B0"],
                        graphic: {
                            type: "text",
                            left: "center",
                            top: "center",
                            style: {
                                text: "",
                                textAlign: "center",
                                fill: "#fff",
                                fontSize: fontSize(0.2)
                            }
                        },
                        series: [{
                            name: "通行次数",
                            type: "pie",
                            radius: ["60%", "90%"],
                            avoidLabelOverlap: false,
                            itemStyle: {
                                borderRadius: 10,
                                borderWidth: 2
                            },
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            data: [{
                                    value: result.student,
                                    name: "学生"
                                },
                                {
                                    value: result.teacher,
                                    name: "教师"
                                },{
                                    value: result.other,
                                    name: "其他人员"
                                }
                            ]
                        }]
                    };
                    myChartPieLeft.hideLoading(); //没有加载出来隐藏加载动画
                    myChartPieLeft.setOption(option);
                    // 响应式变化
                    window.addEventListener(
                        "resize",
                        () => myChartPieLeft.resize(),
                        false
                    );
                    //加载通行人数数字
                    var html = '';
                    for (var i = 0; i < number.length; i += 1) {
                        html += '<div class="card">' + number.charAt(i) + '</div>';
                    }
                    _this.numHtml = html;
                    _this.student = result.student;
                    _this.teacher = result.teacher;
                    _this.other = result.other;
                }
            });
        }
    },
    destroyed() {
        window.onresize = null;
    }
}
function fontSize(res){
    let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
    if (!clientWidth) return;
    let fontSize = 100 * (clientWidth / 1920);
    return res*fontSize;
}
</script>


<style lang="scss">
#top2 {
    height: 40vh;
	.cc-header {
	height: 0.75rem;
	color: #fff;
	font-size: 0.3rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	}
	.pieChart {
	width: 4rem;
	height: 3.5rem;
	}
    .numChart {
        height: 90%;
        .cc-details {
            height:0.6rem;
            display: flex;
            justify-content: center;
            font-size: 0.3rem;
            align-items: center;
			margin-top: 0.3rem;

            .card {
                background-color: #132957;
                color: #FFEB3B;
                height: 0.6rem;
                width: 0.6rem;
                font-size: 0.5rem;
                font-weight: bold;
                line-height: 0.6rem;
                text-align: center;
                margin: 0.05rem;
                float: left;
                border-radius: 0.15rem;
            }
        }

        .cc-main-container {
            position: relative;
            flex: 1;
			display: flex;
			margin-top: 0.4rem;
			height:20vh;
			.ccmc-middle {
                width: 100%;
                height: 100%;
                .active-ring-name {
                    line-height: 0.3rem;
                }
            }

            .ccmc-left,
            .ccmc-right {
                width: 50%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 0.25rem;

                span {
                    font-size: 0.35rem;
                    font-weight: bold;
                }

                .station-info {
                    height: 5vh;
                    display: flex;
                    align-items: center;

                    .legend-color {
                        width: 0.28rem;
                        height: 0.28rem;
                        border-radius: 0.05rem;
                        margin-right: 0.1rem;
                    }
                }
            }

            .ccmc-left {
                align-items: flex-end;
                span {
                    margin-left: 20px;
                }
            }

            .ccmc-right {
                align-items: flex-start;

                span {
                    margin-left: 20px;
                }
            }
        }
    }
}
</style>
